// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import i18n from './pkg/i18n/i18n'
import './globalComponents'
import './pkg/vee-validate/vee-validate'
import axios from './pkg/api/axios'
import api from './pkg/api/index'
import VCalendar from 'v-calendar'
import AuthModule from './pkg/auth-module'
import Clipboard from 'v-clipboard'
import dateFormatter from './pkg/date-formatter'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import {VBHoverPlugin} from 'bootstrap-vue'
import VueTheMask from 'vue-the-mask'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

Vue.use(VueTheMask)
Vue.use(VueAwesomeSwiper)
Vue.use(VBHoverPlugin)
const options = {
  position: 'top-center',
  timeout: 3000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false
}

Vue.use(Toast, options)

axios.interceptors.request.use(
  async config => {
    let token = store.state.auth.token || null
    if (token) {
      config.headers = {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    }

    return config
  },
  error => {
    Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => {
    return response
  },
  async function(error) {
    if (error.response.status === 401) {
      console.log('unauthorized, logging out ...')
      if (error.config.params && error.config.params.auth_second_attempt) {
        store.dispatch('logOut')
      }

      if (store.state.auth.rememberMe) {
        try {
          const res = await axios.post('/token/refresh/', {
            refresh: store.state.auth.refreshToken
          })

          await store.dispatch('updateToken', res.data.access)

          error.config.headers['Authorization'] = `Bearer ${res.data.access}`

          return await axios({
            ...error.config,
            params: {
              auth_second_attempt: true
            }
          })
        } catch (_error) {
          return Promise.reject(_error)
        }
      } else {
        store.dispatch('logOut')
      }
    }
    let errorBack = error.response.data || error.response
    return Promise.reject(errorBack)
  }
)

function handleClick(event) {
  if (store.getters.isLoggedIn) {
    // eslint-disable-next-line no-useless-return
    return
  }

  store.dispatch('openAuthModal', true)
  event.stopImmediatePropagation()
  event.stopPropagation()
  event.preventDefault()
}

Vue.directive('auth-required', {
  inserted(el) {
    const handler = (event) => handleClick(event)
    el.addEventListener('click', handler, true)
  }
})

Vue.config.productionTip = false

// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  componentPrefix: 'vc'
})
Vue.use(Clipboard)

Vue.prototype.$api = api(axios)
Vue.prototype.$auth = new AuthModule()
Vue.prototype.$dateFormatter = dateFormatter

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js